import {
  Card,
  CardContent,
  CardHeader,
  CardMeta,
  Container,
  Divider,
  Header,
  Icon,
  Image,
  Label,
  Responsive,
  Segment,
} from 'semantic-ui-react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMentors } from '../../actions/mentors';

const pageWrapperStyle = {
  backgroundColor: '#f7f9fc',
  minHeight: '100vh',
};

const cardStyle = {
  display: 'flex',
  flexDirection: 'row',
  borderRadius: '15px',
  overflow: 'hidden',
  margin: '10px auto',
  backgroundColor: 'white',
  border: '1px solid rgba(0,0,0,.1)',
  boxShadow: '0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5',
};

const imageColumnStyle = {
  flex: '0 0 auto',
  width: '40%',
  minWidth: '200px',
  maxWidth: '300px',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  backgroundColor: 'white',
};

const imgStyle = {
  width: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
  objectPosition: 'bottom',
  display: 'block',
};

const contentColumnStyle = {
  flex: '1',
  display: 'flex',
  flexDirection: 'column',
  padding: '1em',
  minWidth: 0,
};

const dividerStyle = {
  width: '100%',
  margin: '1em 0',
};

const textStyle = {
  fontSize: '16px',
  lineHeight: 1.5,
  color: '#64748B',
};

const MentorCard = ({ mentor, mobileMode }) => {
  const { id, name, email, image, text } = mentor;

  if (mobileMode) {
    return (
      <Card key={id} style={{ borderRadius: '15px', overflow: 'hidden' }}>
        <Image style={{ backgroundColor: 'white' }} src={image} wrapped ui={false} />
        <Card.Content>
          <Card.Header>
            <Header size='medium' style={{ margin: 0 }}>
              {name}
            </Header>
          </Card.Header>
          <CardMeta style={{ fontSize: '14px', lineHeight: 1.5, color: '#64748B' }}>
            {text}
          </CardMeta>
        </Card.Content>
        <Card.Content extra>
          <Label>
            <Icon name='mail' />
            {email}
          </Label>
        </Card.Content>
      </Card>
    );
  }

  return (
    <div style={cardStyle}>
      <div style={imageColumnStyle}>
        <img src={image} alt={name} style={imgStyle} />
      </div>
      <div style={contentColumnStyle}>
        <CardContent style={{ border: 'none', padding: 0 }}>
          <CardHeader>
            <Header size='large' style={{ margin: 0 }}>
              {name}
            </Header>
          </CardHeader>
          <div style={{ marginTop: 10 }}>
            <Label basic>
              <Icon name='mail' />
              {email}
            </Label>
          </div>
          <Divider style={dividerStyle} />
          <CardMeta style={textStyle}>{text}</CardMeta>
        </CardContent>
      </div>
    </div>
  );
};

class Mentors extends Component {
  UNSAFE_componentWillMount() {
    this.props.getMentors();
  }

  renderMentors(mobileMode = false) {
    return this.props.mentors.map((item) => (
      <MentorCard key={item.id} mentor={item} mobileMode={mobileMode} />
    ));
  }

  render() {
    return (
      <div style={pageWrapperStyle}>
        <Segment inverted textAlign='center' vertical>
          <Container>
            <Header
              as='h1'
              content='Mentorok'
              inverted
              style={{
                fontSize: '3em',
                fontWeight: 'normal',
                marginBottom: 0,
                marginTop: '0.5em',
              }}
            />
          </Container>
        </Segment>

        <Responsive minWidth={768}>
          <Container style={{ paddingTop: '2em', paddingBottom: '5em' }}>
            {this.renderMentors(false)}
          </Container>
        </Responsive>

        <Responsive minWidth={551} maxWidth={767}>
          <Container style={{ paddingTop: '2em', paddingBottom: '5em' }}>
            <Card.Group centered itemsPerRow={2}>
              {this.renderMentors(true)}
            </Card.Group>
          </Container>
        </Responsive>

        <Responsive maxWidth={550}>
          <Container style={{ paddingTop: '2em', paddingBottom: '5em' }}>
            <Card.Group centered itemsPerRow={1}>
              {this.renderMentors(true)}
            </Card.Group>
          </Container>
        </Responsive>
      </div>
    );
  }
}

const mapStateToProps = ({ mentors, user }) => ({ mentors, user });

export default connect(mapStateToProps, { getMentors })(Mentors);
